let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7lEZ8")).then(() => parcelRequire('awZZu'));